import * as lodash from 'lodash';
import { compareInterval, intervalEndTimeSum, intervalStartTimeSum, intervalTimeSum, } from '../utils';
export function applyTimeChanges(intervals, selected_id) {
    if (selected_id === null) {
        return [selected_id, intervals];
    }
    // надо найти ново отредактированный интервал - под него подстроить остальные
    const changed_interval = intervals.find((interval, index) => index === selected_id);
    if (changed_interval == null) {
        return [selected_id, intervals];
    }
    let new_selected_interval = selected_id;
    // Пересечение интервалов
    //            A:  L| --------- |R
    //    B:          ↓           ↓
    // 1. L| --- |R   ↓           ↓
    // 2.     L| -----↓- |R       ↓
    // 3.       L| ---↓-----------↓--- |R
    // 4.             ↓ L| --- |R ↓
    // 5.             ↓       L| -↓----|R
    // 6.             ↓           ↓     L| --- |R
    return [
        new_selected_interval,
        intervals
            .flatMap((interval, index) => {
            if (index === selected_id) {
                return interval;
            }
            const a_l = intervalStartTimeSum(changed_interval);
            const a_r = intervalEndTimeSum(changed_interval);
            const b_l = intervalStartTimeSum(interval);
            const b_r = intervalEndTimeSum(interval);
            // console.log('interval', interval, 'index', index);
            // console.log('b_l', b_l, 'a_l', a_l, 'b_r', b_r, 'a_r', a_r);
            //case 1, 6 - not
            if (b_r <= a_l || b_l >= a_r) {
                // console.log('miss 1 or 6');
                return interval;
            }
            //case 4
            if (b_l > a_l && b_r < a_r) {
                // console.log('4) inside');
                return {
                    ...interval,
                    end_hour: interval.start_hour,
                    end_min: interval.start_min,
                };
            }
            //case 2
            if (b_r > a_l && b_r < a_r) {
                // console.log('2) b.r > a.l && b_r < a_r');
                return {
                    ...interval,
                    end_hour: changed_interval.start_hour,
                    end_min: changed_interval.start_min,
                };
            }
            //case 3
            if (b_l < a_l && b_r > a_r) {
                // console.log('3) add empty');
                new_selected_interval = new_selected_interval + 1;
                //надо сделать два пустых
                return [
                    {
                        ...interval,
                        end_hour: changed_interval.start_hour,
                        end_min: changed_interval.start_min,
                    },
                    {
                        ...interval,
                        start_hour: changed_interval.end_hour,
                        start_min: changed_interval.end_min,
                    },
                ];
            }
            //case 5
            if (b_l > a_l && b_r > a_r) {
                // console.log('5) b_l > a_l && b_r > a_r');
                return {
                    ...interval,
                    start_hour: changed_interval.end_hour,
                    start_min: changed_interval.end_min,
                };
            }
            // console.log('without case');
            return interval;
        })
            .sort(compareInterval),
    ];
}
export function deleteZeroIntervals(intervals, selected_id) {
    let new_selected_id = selected_id;
    return [
        new_selected_id,
        intervals.sort(compareInterval).filter((interval, index) => {
            const is_need = intervalTimeSum(interval.start_hour, interval.start_min) -
                intervalTimeSum(interval.end_hour, interval.end_min) <
                0;
            if (!is_need && selected_id != null && index < selected_id) {
                new_selected_id = selected_id - 1;
            }
            return is_need;
        }),
    ];
}
function needMerge(current, prev) {
    //Если смежные интервалы
    if (intervalStartTimeSum(current) === intervalEndTimeSum(prev)) {
        //Значит пустые интервалы
        if (!('temp_or_mode' in current) && !('temp_or_mode' in prev)) {
            return true;
        }
        if ('temp_or_mode' in current && 'temp_or_mode' in prev) {
            //Значит с одинаковой температурой
            return lodash.isEqual(current.temp_or_mode, prev.temp_or_mode);
        }
    }
    //Начинаются с одного места
    if (intervalStartTimeSum(current) === intervalStartTimeSum(prev)) {
        return intervalEndTimeSum(current) > intervalEndTimeSum(prev);
    }
    //Заканчиваются в одном месте
    if (intervalEndTimeSum(current) === intervalEndTimeSum(prev)) {
        return intervalStartTimeSum(current) > intervalStartTimeSum(prev);
    }
    return false;
}
export function mergeIntervals(intervals) {
    let new_intervals = intervals;
    let done_something = true;
    do {
        done_something = false;
        for (let i = 1; i < new_intervals.length; i++) {
            const current = new_intervals[i];
            const prev = new_intervals[i - 1];
            if (needMerge(current, prev)) {
                // console.log('NEED MERGE', i, prev, current);
                const expanded_interval = {
                    ...current,
                    start_hour: prev.start_hour,
                    start_min: prev.start_min,
                };
                new_intervals = [
                    ...new_intervals.slice(0, i - 1),
                    expanded_interval,
                    ...new_intervals.slice(i + 1),
                ];
                // console.log('AFTER MERGE:', new_intervals);
                done_something = true;
                break;
            }
        }
    } while (done_something);
    return new_intervals;
}
export function changeIntervals(intervals, selected_id, changes) {
    if (selected_id === null) {
        return intervals;
    }
    return intervals.map((interval, index) => index === selected_id
        ? {
            ...interval,
            ...changes,
        }
        : interval);
}
